export default function Youtube({
	onClick,
	id: buttonId,
	value,
	type,
	isCustomUrl,
	socialData,
	children,
}) {
	if (!value || !value.length) {
		return false;
	}

	function doOnClick(e) {
		onClick(e, buttonId);
	}

	const url =
		(socialData.domain ? socialData.domain : '') +
		('1' === isCustomUrl ? 'c/' : 'channel/') +
		value;

	return (
		<a onClick={doOnClick} href={url} className="btn">
			{children}
		</a>
	);
}
